/**
 * Lets a page take a browser back or forward for itself, unseen by React Router.
 *
 * React Router's history listens to `popstate` on window, and every pop it
 * sees becomes a location change: the route's loadData runs again and the
 * page scrolls to the top. Browsers call window listeners in different
 * orders (Chromium in the order they were added, WebKit capture listeners
 * first), so the guard must be added before the router's history exists:
 * setupPopStateGuard() runs in src/index.js before the app renders.
 *
 * Used by the listing page's full-screen photo viewer, which the back button
 * closes.
 */

let popStateHandler = null;
let isSetUp = false;

const onPopState = e => {
  if (popStateHandler && popStateHandler(e)) {
    e.stopImmediatePropagation();
  }
};

/**
 * Add the guard's popstate listener. Call once, before the router renders.
 */
export const setupPopStateGuard = () => {
  if (isSetUp || typeof window === 'undefined') {
    return;
  }
  window.addEventListener('popstate', onPopState, true);
  isSetUp = true;
};

/**
 * Set the function that may take a pop. It gets the PopStateEvent and returns
 * true when it took it, in which case no other popstate listener (the
 * router's) sees it. null removes it.
 *
 * @param {Function|null} handler
 */
export const setPopStateHandler = handler => {
  popStateHandler = handler;
};
